module.exports = __webpack_public_path__ + "static/media/TimeSaving.c6db5e65.svg";